import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIcon, MatIconModule } from "@angular/material/icon";

@Component({
  standalone: true,
  selector: 'app-notification-dialog',
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
  template: `
    <div class="notification-container" [ngStyle]="{'background': data.color || '#FFEADF'}">
      <div class="notification-header">
        <strong><span class="warning-icon" *ngIf="data.header !== 'Request Approved'"><mat-icon>warning</mat-icon></span> {{data.header}}</strong>
        <span class="notification-time">now</span>
    </div>
    <div class="notification-body">
        {{data.text}} <br>
    </div>
    <span class="close-btn" (click)="onClose()"><mat-icon>close</mat-icon> Close</span>
    </div>
  `,
  styles: [`
    .notification-container {
      position: fixed;
      bottom: 20px;
      right: 20px;

      box-shadow: 0 4px 8px rgba(0,0,0,0.2);
      border-radius: 6px;
      width: 400px;
      padding: 20px;
      z-index: 1000;
      animation: fadeIn 0.5s ease;
    }
    .notification-header {
      display: flex;
      align-items: center; 
      justify-content: space-between;
    }

    .notification-header strong {
      display: flex;
      align-items: center;  
      gap: 6px;            
    }

    .warning-icon {
      display: flex;
      align-items: center;
      font-size: 12px
    }
    .notification-body {
      margin-top: 20px;
      font-size: 14px;
      color: #636363
    }
    .close-btn {
      display: inline-flex;    
      align-items: center;     
      gap: 4px;                
      cursor: pointer;         
      color: #555;   
      margin-left: 330px      
    }
    .close-btn:hover {
      color: #d32f2f;        
    }
    .notification-time {
      font-weight: normal;
      color: gray;
      margin-right: 8px;
      font-size: 14px
    }
    @keyframes fadeIn {
      from { opacity: 0; transform: translateY(20px); }
      to   { opacity: 1; transform: translateY(0); }
    }
    
  `]
})
export class NotificationDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<NotificationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  onClose() {
    this.dialogRef.close();
  }
}
